import { IImage } from '../../../api/images';

export const sortImages = (images: IImage[]) => {
	if (!images) { return []; }
	return images.slice().sort((i1, i2) => i1.sort_order < i2.sort_order ? -1 : 1);
};
